module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-analytic-1.cf98ceed.svg";